import React from 'react';
import { useTranslation } from 'next-i18next';
import Button from '@components/atoms/button/button';
import Icon from '@components/atoms/icon/icon';
import { getTranslatedHotFilterName } from '@helpers/utils/hot-filters/hot-filters-parsing-util';
import styles from './hot-filters-loading.module.scss';

// TODO: Used for loading state UI;
const FILTERS_MOCK = ['Brand', 'Category', 'Color', 'Condition', 'Material'];

const HotFiltersLoading = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.hotFiltersLoading}>
      {FILTERS_MOCK.map((filter: string) => (
        <div
          className={styles.hotFiltersLoading__item}
          key={filter}
        >
          <Button
            disableDefaultStyling
            className={styles.hotFiltersLoading__item__button}
            disabled={true}
          >
            <span>{t(getTranslatedHotFilterName(filter))}</span>
            <Icon
              className={styles.hotFiltersLoading__item__button__icon}
              name={'small-dropdown-down-default'}
              ariaHidden
            />
          </Button>
        </div>
      ))}
    </div>
  );
};

export default HotFiltersLoading;
